export const promotionCategoryCode = "11136";
export const discontinuedCategoryCode = "11831";
